import { DayTimelineRangeDisplay } from "../../../../components/RRule/DayTimelineRangeDisplay.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/activity-evals/instance/InstancePeriodTrack.tsx
function InstancePeriodTrack({ endsAt, startsAt, timezone }) {
	return /* @__PURE__ */ jsx(DayTimelineRangeDisplay, {
		endsAt,
		startsAt,
		timezone
	});
}
//#endregion
export { InstancePeriodTrack };

//# sourceMappingURL=InstancePeriodTrack.js.map